import React from 'react';
import { gql } from '@yi/core';
import { i18n_get_started } from '@yi/i18n/phrases/i18n_get_started';

import { utilities } from '~/common';
import { useConvertedContentFrom } from '~/src/common/sign-up/converted-content-from';
import { useLocale } from '~/src/components/LocaleProvider';
import { SetEmailForm } from '~/src/components/SetEmailForm';

import { StyledSetEmailForm } from './elements';

type Props = { returnUrl: string };

export const PaywallSetEmailForm: React.FC<Props> = ({ returnUrl }) => {
  const { locale } = useLocale();
  const defaultSignupPath = utilities.getLocalizedDefaultSignupPath(locale, '/create-account');

  const { addToUrlConvertedContentFrom } = useConvertedContentFrom();

  const path = addToUrlConvertedContentFrom({
    returnUrl,
    targetUrl: defaultSignupPath,
  });

  return (
    <StyledSetEmailForm>
      <SetEmailForm
        formStyle={{ width: '75%', margin: 'auto' }}
        buttonStyle={{ width: '70%' }}
        buttonDesc={i18n_get_started(locale)}
        form_id="e1eea948-329d-4be8-95c6-a9996ca8d9ec"
        form_name="classes_paywall"
        registration_type="custom_form"
        filledDark
        language={
          locale === 'es' ? gql.typesClient.Language.SPANISH : gql.typesClient.Language.ENGLISH
        }
        return_url={path}
      />
    </StyledSetEmailForm>
  );
};
